export default "__VITE_ASSET__BIJ4byRA__"